import React from "react";
function RotateSelector({ onTransform, disabled }) {

  /**
   * Rotates the object by 90 degrees when the user clicks on the rotate button.
   *
   * @param {React.MouseEvent} event - The click event object.
   * @returns {void}
   */
  const rotateObject = (event) => {
    if (!disabled) {
      onTransform(event, "rotate", 90);
    }
  };

  return (
    <div
      className="toolbar-button"
      data-test={"image-rotate"}
      onClick={rotateObject}
      style={disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}>
      <i className="fas fa-sync-alt"></i>
    </div>
  );
}


export default RotateSelector;